import React, { useEffect, useState } from "react";
import UserProfile from "./UserProfile";
import useProfile from "../Controller/useProfile.controller";
import { SkeletonProfileForm } from "./SkeletonProfileForm";
import "./ProfileSkeleton.css";
export default function Profile() {
  const [user, setUser] = useState(null);
  const { fetchUser, handleSave } = useProfile({ setUser });
  useEffect(() => {
    const userId = sessionStorage.getItem("userId") || localStorage.getItem("userId");
    if (userId) fetchUser(userId);
  }, [fetchUser]);
  const handleSaveAndRefetch = async (userId, updated) => {
    await handleSave(userId, updated);
    await fetchUser(userId);
  };
  if (!user) {
    return <SkeletonProfileForm />;
  }
  return (
    <UserProfile user={user} onSave={(updated) => handleSaveAndRefetch(user.id, updated)} />
  );
}
